import React, { PureComponent } from 'react';
import Modal from './Modal.js';
import Text from '../Text.js';
import TextInput from '../TextFields/TextInput.js';
import BubbleSelectBlock from '../BubbleSelectBlock.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as Services from '../../services/index.js';
import * as localizationMaps from '../../localization/maps.js';

/**
 * 
 * @param {*} meta 
 */
const buildYearsOptions = meta => {
  const {
    enrollmentDate
  } = meta;
  const years = [i18n.t(tokens.labels.claims.allYears)];
  const currentYear = new Date().getFullYear();
  const startYear = enrollmentDate ? new Date(enrollmentDate * 1000).getFullYear() : currentYear;

  // If they enrolled in the current year there is no need to show anything other than the current year and "All Years"
  if (currentYear === startYear) {
    return [...years, currentYear.toString()];
  }

  /*
   * Otherwise create an array from the year they enrolled to the current year
   * Then turn the numbers into strings
   * We add plus one to the length to include the current year
   */
  Array.from({
    length: currentYear - startYear + 1
  }, (v, k) => k + startYear).forEach(year => years.push(year.toString()));
  return years;
};
class FilterClaims extends PureComponent {
  state = {
    patient: this.props.activeFilters.patient ? localizationMaps.fromEnglish("patients", this.props.activeFilters.patient) : i18n.t(tokens.labels.claims.allPatients),
    category: this.props.activeFilters.category ? localizationMaps.fromEnglish("categories", this.props.activeFilters.category) : i18n.t(tokens.labels.claims.allCategories),
    service: this.props.activeFilters.service ? localizationMaps.fromEnglish("benefits", this.props.activeFilters.service) : i18n.t(tokens.labels.claims.allServiceTypes),
    status: this.props.activeFilters.status ? this.props.activeFilters.status : 'All Statuses',
    year: this.props.activeFilters.year ? localizationMaps.fromEnglish("yearOptions", this.props.activeFilters.year) || this.props.activeFilters.year : i18n.t(tokens.labels.claims.allYears),
    sortBy: this.props.activeSort?.sortBy ? this.props.activeSort.sortBy : false,
    sortDirection: this.props.activeSort?.sortDirection ? this.props.activeSort.sortDirection : false,
    serviceOptions: this.props.activeFilters?.service ? [this.props.activeFilters?.service] : ['All Service Types'],
    patientOptions: ['All Patients'],
    yearOptions: buildYearsOptions(this.props.user)
  };
  async componentDidMount() {
    if (this.props.dependents && !this.props.user.isDependent) {
      const dependents = await this.props.dependents.map(dependent => `${dependent.firstname} ${dependent.lastname}`);
      this.setState({
        patientOptions: [i18n.t(tokens.labels.claims.allPatients), `${this.props.user.firstname} ${this.props.user.lastname}`, ...dependents]
      });
    } else {
      this.setState({
        patientOptions: [i18n.t(tokens.labels.claims.allPatients), `${this.props.user.firstname} ${this.props.user.lastname}`]
      });
    }

    // Set the initial value for serviceOptions based on the current category filter value (if it exists)
    if (this.props.activeFilters.category) {
      this._setServiceOptions(this.props.activeFilters.category, this.props.activeFilters.service);
    }
  }
  _applyFilters = () => {
    let {
      sortBy,
      sortDirection,
      category,
      service,
      year,
      patient,
      status
    } = this.state;
    if (localizationMaps.toEnglish("patients", patient) === "All Patients") {
      patient = "All Patients";
    }
    if (localizationMaps.toEnglish("yearOptions", year) === "All Years") {
      year = "All Years";
    }
    const filters = {
      category: localizationMaps.toEnglish("categories", category),
      service: localizationMaps.toEnglish("benefits", service),
      year,
      patient
    };
    if (this.props.isMasterSite) {
      filters.status = status;
      if (!filters.status) {
        filters.status = "All Statuses";
      }
    }

    // if sortBy is false, set to false so that the sortBy and sortDirection are not sent to the API
    let sort = sortBy ? {
      sortBy,
      sortDirection
    } : false;
    this.props.applyFilters(filters, sort);
  };
  _selectPatient = async event => {
    await this.setState({
      patient: event.target.value
    });
  };
  _selectCategory = async event => {
    await this.setState({
      category: event.target.value
    });
    this._setServiceOptions(localizationMaps.toEnglish("categories", event.target.value));
  };
  _selectService = async event => {
    await this.setState({
      service: event.target.value
    });
  };
  _setServiceOptions = (category, serviceValue = null) => {
    let options = ['All Service Types'];
    if (category !== 'All Categories') {
      options = ['All Service Types', ...this.props.hsaClaimTypes[category].reverse()];
    }
    this.setState({
      serviceOptions: options,
      service: serviceValue ? localizationMaps.fromEnglish("benefits", serviceValue) : localizationMaps.fromEnglish("benefits", options[0])
    });
  };
  _handleInputChange = (type, event, isValue) => {
    this.setState({
      [type]: isValue ? event : event.target.value
    });
  };
  _handleSortByChange = field => {
    if (field === this.state.sortBy) {
      // Deactivate sortBy and sortDirection
      this.setState({
        sortBy: false,
        sortDirection: false
      });
    } else {
      // Set sortBy to new value
      const sortBy = field;
      // if sortDirection is not yet set. set it to the default
      const sortDirection = this.state.sortDirection ? this.state.sortDirection : 'newestFirst';
      this.setState({
        sortBy,
        sortDirection
      });
    }
  };
  render() {
    const categoryOptions = [...Services.selectFieldOptions.categoryOptions(), i18n.t(tokens.labels.claims.allCategories)];
    const styles = {
      containerStyle: {
        height: 752,
        maxHeight: '90vh',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: '40px 0'
      },
      formStyle: {
        height: '100%',
        maxHeight: '100%',
        padding: '5px 40px'
      },
      titleIconWrapperStyle: {
        width: 'auto',
        paddingLeft: 40,
        paddingRight: 40,
        paddingBottom: 0
      },
      body: {
        flex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      testid: "filter-claims-modal",
      open: true,
      onClose: this.props.close,
      "aria-labelledby": "Filter Claims",
      title: i18n.t(tokens.labels.claims.filterAndSortClaims),
      primaryButton: {
        label: i18n.t(tokens.buttons.applyFilters),
        onClick: this._applyFilters
      },
      secondaryButton: {
        label: i18n.t(tokens.buttons.resetFilters),
        onClick: this.props.resetFilters,
        transparent: true
      },
      loader: this.props.loading
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.body
    }, !this.props.isLifeStyle ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "5px 0 0 0"
    }, i18n.t(tokens.labels.claims.category)), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.claims.selectCategory),
      variant: "outlined",
      value: this.state.category,
      onChange: this._selectCategory,
      select: true,
      required: true,
      fullWidth: true,
      selectOptions: categoryOptions
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.claims.serviceType)), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.claims.selectService),
      variant: "outlined",
      value: this.state.service,
      onChange: this._selectService,
      select: true,
      required: true,
      fullWidth: true,
      selectOptions: this.state.serviceOptions.map(option => localizationMaps.fromEnglish("benefits", option))
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.claims.serviceType)), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.claims.selectService),
      variant: "outlined",
      value: this.state.service,
      onChange: this._selectService,
      select: true,
      required: true,
      fullWidth: true,
      selectOptions: ['All Service Types', ...this.props.lsaClaimTypes].map(option => localizationMaps.fromEnglish("benefits", option))
    })), this.props.isMasterSite ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, "Status"), /*#__PURE__*/React.createElement(TextInput, {
      label: "Select Status",
      variant: "outlined",
      value: this.state.status,
      onChange: event => this._handleInputChange('status', event),
      select: true,
      required: true,
      fullWidth: true,
      selectOptions: ['All Statuses', 'Pending', 'Approved', 'Referred', 'Paid', 'Declined', 'Suspended', 'Incomplete', 'Reversed']
    })) : null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.claims.yearServiceDate)), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.claims.selectYear),
      variant: "outlined",
      value: this.state.year,
      onChange: event => this._handleInputChange('year', event),
      select: true,
      required: true,
      fullWidth: true,
      selectOptions: this.state.yearOptions
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.claims.patient)), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.claims.selectPatient),
      variant: "outlined",
      value: this.state.patient,
      onChange: this._selectPatient,
      select: true,
      required: true,
      fullWidth: true,
      selectOptions: this.state.patientOptions
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0",
      customStyle: {
        fontWeight: 500
      }
    }, i18n.t(tokens.labels.claims.sortBy)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.claims.serviceDate),
        selected: this.state.sortBy === 'serviceDate',
        field: 'serviceDate'
      },
      second: {
        title: i18n.t(tokens.labels.claims.submissionDate),
        selected: this.state.sortBy === 'submissionDate',
        field: 'submissionDate'
      },
      handleChange: this._handleSortByChange,
      customStyle: {
        flex: 'none',
        alignSelf: "center"
      },
      allowToggleOff: true
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0",
      customStyle: {
        fontWeight: 500
      }
    }, i18n.t(tokens.labels.claims.sortDirection)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.claims.oldestFirst),
        selected: this.state.sortDirection === 'oldestFirst',
        field: 'oldestFirst'
      },
      second: {
        title: i18n.t(tokens.labels.claims.newestFirst),
        selected: this.state.sortDirection === 'newestFirst',
        field: 'newestFirst'
      },
      handleChange: async field => {
        // Don't do anything if sort by is not set
        if (!this.state.sortBy) {
          return;
        }
        await this._handleInputChange('sortDirection', field, true);
      },
      customStyle: {
        flex: 'none',
        alignSelf: "center"
      },
      allowToggleOff: true
    })), /*#__PURE__*/React.createElement("span", {
      id: "filterclaimsform"
    }));
  }
}
export default FilterClaims;